var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgSpark = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 73,
    viewBox: "0 0 71 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.62786 19.7959L3 8",
    stroke: "url(#paint0_linear_985_71371)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.3973 16.479L32.5752 3",
    stroke: "url(#paint1_linear_985_71371)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.448 25.1722L57.2344 15.8289",
    stroke: "url(#paint2_linear_985_71371)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.2133 42.974L67.292 39.5071",
    stroke: "url(#paint3_linear_985_71371)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.801 61.1556L59.0723 69.9631",
    stroke: "url(#paint4_linear_985_71371)",
    strokeWidth: 6,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_985_71371",
    x1: 3.4359,
    y1: 7.75507,
    x2: 10.0638,
    y2: 19.5509,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_985_71371",
    x1: 33.0733,
    y1: 3.04353,
    x2: 31.8954,
    y2: 16.5225,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_985_71371",
    x1: 57.5796,
    y1: 16.1905,
    x2: 47.7933,
    y2: 25.5339,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_985_71371",
    x1: 67.4201,
    y1: 39.9904,
    x2: 54.3415,
    y2: 43.4573,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB801"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_985_71371",
    x1: 58.7468,
    y1: 70.3427,
    x2: 48.4756,
    y2: 61.5352,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC83C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB801"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSpark);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/spark.f3e2635cdeebba05c0fa1d24a0061181.svg";